// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1HOir","visuallyhidden":"_7JJSj","hide-text":"_2N5yK","root":"_1dZee _25KE7","center":"_2uEFz","noprint":"_2SaPd"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-streamer/styles/pluss-indicator.scss
 ** module id = 1017
 ** module chunks = 2
 **/